import type {CreateServiceFunctionFormPayload} from "./create-service-function.schema";

import {createServiceFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceFunctionKeys, serviceFunctionMutationKeys} from "../../../serviceFunction-keys";

export function createServiceFunctionMutationOptions() {
  return mutationOptions({
    mutationFn: (payload: CreateServiceFunctionFormPayload) => createServiceFunction(payload),
    mutationKey: serviceFunctionMutationKeys.createServiceFunction,
    onSuccess: async (_serviceFunctionId, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: serviceFunctionKeys.lists()});
    },
  });
}
